import {getEntryPointData, getEntryPointDataSuccess} from "modules/actions/entryActions";
import {RequestState} from "modules/enums";
import {createReducer} from "redux-act";
import RallySSO from "modules/utils/SSO/rallySSO";

export interface IPlatform {
	entryDataState: RequestState;
	isNative: boolean;
}

const initialState: IPlatform = {
	entryDataState: RequestState.IDLE,
	isNative: RallySSO.IS_NATIVE,
};

export const platform = createReducer({}, initialState)
	.on(getEntryPointDataSuccess, (state) => ({
		...state,
		entryDataState: RequestState.Received,
	}))
	.on(getEntryPointData, (state) => ({
		...state,
		entryDataState: RequestState.Requested,
	}));
